import React from "react";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import Footer from "app/layout/Footer";
import MDBox from "shared/components/MDBox";
import { TablaGerencia } from "./components/TablaGerencia";

const TableroGerencia = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <MDBox mt={2} mb={0}>
        <TablaGerencia />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default TableroGerencia;
